import { Mail, Linkedin, Instagram, FileDown, Globe } from 'lucide-react';
import { contact, profile } from '../data/portfolio';
import { FadeUp } from './Reveal';

const CHANNELS = [
    { key: 'worklyne', label: 'Worklyne', href: contact.worklyne, icon: Globe, testid: 'contact-worklyne' },
    { key: 'email', label: 'Email', href: `mailto:${contact.email}`, icon: Mail, testid: 'contact-email' },
    { key: 'linkedin', label: 'LinkedIn', href: contact.linkedin, icon: Linkedin, testid: 'contact-linkedin' },
    { key: 'instagram', label: 'Instagram', href: contact.instagram, icon: Instagram, testid: 'contact-instagram' },
];

export default function ContactSection() {
    return (
        <section id="contact" data-testid="contact-section" className="relative z-10 bg-ink pb-24 pt-8 md:pb-32">
            <div className="mx-auto max-w-[1300px] px-6">
                <FadeUp>
                    <div className="relative overflow-hidden rounded-3xl border border-white/10 bg-panel/70 p-9 md:p-16">
                        <div
                            className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full"
                            style={{ background: 'radial-gradient(circle, rgba(0,242,254,0.12), transparent 65%)' }}
                        />
                        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-neon">
                            Open Channel
                        </p>
                        <h2 className="mt-4 max-w-2xl font-display text-3xl font-extrabold leading-tight text-snow md:text-5xl">
                            Curious minds reach out. Knowledge flows back.
                        </h2>
                        <p className="mt-4 max-w-xl text-sm text-mist md:text-[15px]">
                            Whether it’s QA architecture, DeFi testing, Worklyne, or just a good question: the channel is open.
                        </p>

                        <div className="mt-10 flex flex-wrap items-center gap-3">
                            {CHANNELS.map(({ key, label, href, icon: Icon, testid }) => (
                                <a
                                    key={key}
                                    data-testid={testid}
                                    href={href}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="group inline-flex items-center gap-2.5 rounded-full border border-white/[0.12] bg-white/[0.03] px-5 py-2.5 text-sm text-snow transition-all hover:border-neon/50 hover:text-neon"
                                >
                                    <Icon size={15} strokeWidth={1.8} />
                                    <span className="font-sub">{label}</span>
                                </a>
                            ))}
                            <a
                                data-testid="contact-resume-download"
                                href={contact.resumePath}
                                download="Ujjwal_Praveen_Resume.pdf"
                                className="inline-flex items-center gap-2.5 rounded-full bg-neon px-6 py-2.5 text-sm font-semibold text-ink transition-transform hover:scale-[1.03] active:scale-95"
                            >
                                <FileDown size={15} strokeWidth={2} />
                                <span className="font-sub">Download résumé</span>
                            </a>
                        </div>

                        <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.2em] text-mist/50">
                            Every channel above is live and reachable
                        </p>
                    </div>
                </FadeUp>
            </div>
        </section>
    );
}

export { profile };
